import { render, staticRenderFns } from "./HeaderAbout.vue?vue&type=template&id=52994d7d&scoped=true&"
import script from "./HeaderAbout.vue?vue&type=script&lang=js&"
export * from "./HeaderAbout.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAbout.vue?vue&type=style&index=0&id=52994d7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52994d7d",
  null
  
)

export default component.exports